import { Component } from 'react'

export default class extends Component {
  static displayName = 'DropdownPanel'
  render() {
    return this.props.children || null
  }
}
